const rankingItems = [
  { id: 1, rank: 1, title: '迷雾追踪', category: '悬疑', views: '128.6万', trend: 'up' },
  { id: 2, rank: 2, title: '夏日恋歌', category: '爱情', views: '96.3万', trend: 'up' },
  { id: 3, rank: 3, title: '龙拳出击', category: '动作', views: '87.9万', trend: 'up' },
  { id: 4, rank: 4, title: '时光回响', category: '剧情', views: '74.2万', trend: 'stable' },
  { id: 5, rank: 5, title: '笑傲江湖之风云再起', category: '喜剧', views: '68.5万', trend: 'down' },
  { id: 6, rank: 6, title: '岁月如歌', category: '纪录', views: '59.1万', trend: 'up' },
];

const rankColors = ['bg-red-600', 'bg-orange-500', 'bg-amber-500'];

export default function RankingSection() {
  return (
    <section id="ranking" className="section-scroll py-14 md:py-20 bg-gray-50/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-red-600 text-xs md:text-sm font-semibold tracking-widest uppercase mb-2">人气排行</p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900">热播榜单</h2>
          <p className="mt-2 text-gray-500 text-sm md:text-base max-w-lg mx-auto">
            91免费视频网站本周播放量最高的国产影片排行榜
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-white rounded-2xl border border-gray-100 overflow-hidden">
            {rankingItems.map((item, index) => (
              <a
                key={item.id}
                href="#ranking"
                onClick={(e) => e.preventDefault()}
                className={`flex items-center gap-3 md:gap-4 px-4 md:px-6 py-3.5 md:py-4 cursor-pointer transition-all duration-200 hover:bg-red-50/50 ${
                  index < rankingItems.length - 1 ? 'border-b border-gray-50' : ''
                }`}
              >
                <div className={`w-7 h-7 md:w-8 md:h-8 rounded-lg flex items-center justify-center flex-shrink-0 ${
                  index < 3
                    ? `${rankColors[index]} text-white`
                    : 'bg-gray-100 text-gray-400'
                }`}>
                  <span className="text-xs md:text-sm font-bold">{item.rank}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <h3 className="text-sm md:text-base font-semibold text-gray-900 truncate">{item.title}</h3>
                    <span className="px-1.5 py-0.5 rounded-md bg-gray-100 text-gray-500 text-xs whitespace-nowrap">
                      {item.category}
                    </span>
                  </div>
                </div>
                <div className="flex items-center gap-2 md:gap-3 flex-shrink-0">
                  <span className="text-xs md:text-sm text-gray-400 whitespace-nowrap">{item.views}次</span>
                  <span className={`text-xs md:text-sm ${
                    item.trend === 'up' ? 'text-red-500' : item.trend === 'down' ? 'text-green-500' : 'text-gray-400'
                  }`}>
                    <i className={`${
                      item.trend === 'up' ? 'ri-arrow-up-line' : item.trend === 'down' ? 'ri-arrow-down-line' : 'ri-subtract-line'
                    }`}></i>
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}